import NavegadorAcaoEnum from "./NavegadorAcaoEnum";
import AppState from "../model/AppState";
import AlertaModel from "../model/AlertaModel";
import LogUtil from "./LogUtil";

class NavegadorUtil {
  public static baseEndpoint: string = "";

  static share(titulo: string, texto: string, url: string): void {
    (navigator as any)
      .share({
        title: titulo,
        text: texto,
        url: url,
      })
      .then(() => LogUtil.log("Compartilhado com sucesso"))
      .catch((error: string) => LogUtil.log(`Erro ao compartilhar: ${JSON.stringify(error)}`));
  }

  static alerta(
    componente: React.Component | null | undefined,
    texto: string,
    id?: string,
    acao?: NavegadorAcaoEnum,
    rotuloAcao?: string
  ): void {
    AppState.setAlerta({
      exibirModal: true,
      mensagem: texto,
    } as AlertaModel);
    if (componente) {
      componente.forceUpdate();
    }
  }

  static alertaModal(texto: string): void {
    alert(texto);
  }

  static redirect(url: string, history: any): any {
    return history.push(url);
  }

  static getUrl(url: string): string {
    return NavegadorUtil.baseEndpoint + url;
  }
}

export default NavegadorUtil;
